module.exports = __webpack_public_path__ + "static/media/Lens_Card_JP_new.409bd218.png";